export function setState(state, keyValue = []) {
  if (!Array.isArray(keyValue)) {
    return;
  }
  state[keyValue[0]] = keyValue[1];
}

export function setClaims(state, claims) {
  state.claims = claims;
}

export function setSelectedStatus(state, status) {
  state.selectedStatus = status;
}
